import { Stack } from "@altimateai/lego";
import { Typography } from "@altimateai/lego";
import { RobotIcon } from "@/assets/icons";

const PlaygroundHelloMessage: React.FC = () => {
  return (
    <Stack justify="center" align="center" direction="column">
      <Stack
        justify="center"
        align="center"
        className={
          "al-size-20 al-rounded-full al-bg-gradient-to-br al-from-blue-500 al-to-[#8F00FF]"
        }
      >
        <RobotIcon className="al-text-white al-size-12" />
      </Stack>
      <Typography variant="h3" className="!al-text-brand">
        Welcome to Studio
      </Typography>
      <Typography variant="body">Your AI-powered data workflow assistant</Typography>
    </Stack>
  );
};

export default PlaygroundHelloMessage;
